<div class="layout-fluid-constrained layout-align-center white-wrapper">
  @if (staticPage) {
    <h1 class="layout-mb-20">{{ getTranslation(staticPage).name }}</h1>
    <div class="formatted-text">
      @if (discountBoxes.length) {
        <div class="discount-grid-boxes-wrapper">
          @for (discountBox of discountBoxes; track $index) {
            <div class="discount-grid-box">
              <div class="name">{{ getTranslation(discountBox).name }}</div>
              <div class="text" [innerHTML]="getTranslation(discountBox).text"></div>
            </div>
          }
        </div>
      }
      <div [innerHTML]="getTranslation(staticPage).text"></div>
    </div>
  }
</div>

<div class="buildings-section">
  <div class="layout-fluid-constrained layout-align-center o-hidden">
    @if (easyFinancePaymentAccounts.length) {
      <div class="minizaem-payment-accounts layout-mt-20">
        <div class="labels">
          <div>Описание</div>
          <div>КИН</div>
        </div>
        <div class="payment-account">
          <div class="name">ИЗИ ПЕЙ ЕАД</div>
          <div class="number">Микросметка с кл. номер</div>
          <div class="desc">0918884837</div>
        </div>
        <div class="labels">
          <div>IBAN</div>
          <div>BIC</div>
        </div>
        @for (easyFinancePaymentAccount of easyFinancePaymentAccounts; track $index) {
          <div class="payment-account">
            <div class="name">{{ easyFinancePaymentAccount.bankName }}</div>
            <div class="number">{{ easyFinancePaymentAccount.identifier }}</div>
            <div class="desc">{{ easyFinancePaymentAccount.bicCode }}</div>
          </div>
        }
      </div>
    }
  </div>
  <app-loan-slider></app-loan-slider>
</div>
<app-contact-section></app-contact-section>
